import React, { useContext, useEffect } from 'react'
import { AccountsContext } from 'AccountsContext'
import {
  getCommonClevertapParams,
  triggerClevertap,
} from 'AccountsUtils'
import Modal from '../Modal'
import './SupportHeader.css'

const SupportHeader = ({ verticalName, setRefetchCases }) => {
  const {
    customerCareNumber,
    showSupportNumbers,
    callbackOptionsData,
    selectedTrip,
    tripOptionsAPIData,
    closeModal,
    fetchCallingNumber
  } = useContext(AccountsContext)

  useEffect(() => {
    if (customerCareNumber === 0) {
      fetchCallingNumber()
    }
  }, [])

  const sosCheck = () => (callbackOptionsData &&
  callbackOptionsData.caseType &&
  callbackOptionsData.caseType.toLowerCase() === 'sos')

  const airSOSCheck = () => verticalName && verticalName.toLowerCase() === 'air' &&
  (tripOptionsAPIData &&
    tripOptionsAPIData.l1 &&
    ['cancellation charges', 'change flight'].indexOf(tripOptionsAPIData.l1.toLowerCase()) > -1)

  const switchMsg = () => {
    let returnMsg = 'There was an issue updating your support request. This is usually temporary. Please try again in a few minutes.'
    let msgHeader = 'Cleartrip Support'
    if (selectedTrip && selectedTrip.bookingStatus) {
      switch (selectedTrip.bookingStatus.toLowerCase()) {
        case 'payment initialized':
          msgHeader = 'Payment Initialized'
          returnMsg = 'Checking with your bank for payment details.Payments are usually confirmed in 20-30 minutes.'
          break
        case 'payment refund':
          msgHeader = 'Payment Refund'
          returnMsg = 'The refund is processed from our end.You will receive a reference number on your email id to help track the refund status with your bank.'
          break
        case 'payment failed':
          msgHeader = 'Payment Failed'
          returnMsg = 'If you were charged, the full booking amount will be refunded to your original payment mode.The refund will be processed in 2 business days and should reflect in your bank in 7-8 business days.'
          break
        default:
          msgHeader = 'Cleartrip Support'
          returnMsg = 'There was an issue updating your support request. This is usually temporary. Please try again in a few minutes.'
          break
      }
    }
    if (sosCheck()) {
      returnMsg = airSOSCheck() ?
        `Thanks for reaching us.For last minute cancellations and
        flight changes please reach out to the airline directly for making any changes.` :
        `Please call ${customerCareNumber || '+91 95 95 333 333'} for support related to hotel and activitiy bookings. 
        One of our Cleartrippers will reach out to solve your query once we receive your request.`
      msgHeader = airSOSCheck() ? 'Booking Change Alert' : 'Call Customer Support'
    }
    return { returnMsg, msgHeader }
  }
  const ReactEl = () => (
    <If condition={switchMsg()}>
      <p>
        {switchMsg().returnMsg}
      </p>
    </If>
  )
  const primaryButtonConfig = {
    visible: false,
    text: '',
    action: ''
  }
  const secondaryButtonConfig = {
    visible: false,
    text: '',
    action: ''
  }

  const closeSupportHandler = e => {
    const CommonClevertapParams = getCommonClevertapParams()
    const cleverTapData = {
      action_name: 'close_support_request_click',
      trip_id: selectedTrip.tripId,
      domain: CommonClevertapParams.domain,
      source_page: CommonClevertapParams.source_page,
      platform: CommonClevertapParams.platform,
      trip_status: selectedTrip.bookingStatus,
      product: selectedTrip ? selectedTrip.verticalName : '',
      logged_id: 'Yes',
      emial_id: selectedTrip?.contactDetails?.email
    }
    triggerClevertap('Account_UI_Action', cleverTapData)
    closeModal()
    if (setRefetchCases) {
      setRefetchCases(true)
    }
  }

  return (
    <React.Fragment>
      <div className="support_header__container">
        <span className="w-60p ta-c fs-16 fw-500 flex-1">Support</span>
        <span className="support-header-options w-20p ta-c">
          <svg id="close" viewBox="0 0 14 14" width="15px" height="15px" onClick={ e => { closeSupportHandler(e) }}>
            <title>close</title>
            <path d="M14 1.4L12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4l5.6 5.6 1.4-1.4L8.4 7z" fillRule="evenodd" />
          </svg>
        </span>
      </div>
      <If condition={showSupportNumbers}>
        <div className="modal-outer" role="alert">
          <Modal
            content={<ReactEl />}
            primaryButton={primaryButtonConfig}
            secondaryButton={secondaryButtonConfig}
            header={switchMsg() ? switchMsg().msgHeader : 'Cleartrip Support'}
          />
        </div>
      </If>
    </React.Fragment>
  )
}

export default SupportHeader
